'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = CropViewer;

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _rcSlider = require('rc-slider');

var _rcSlider2 = _interopRequireDefault(_rcSlider);

var _Icon = require('./Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

var maxValue = 1.7777;
function CropViewer(props) {
    var min = props.min,
        prefixCls = props.prefixCls,
        value = props.value;

    if (min > maxValue || Math.abs(min - maxValue) < 0.2) {
        return React.createElement("div", { className: prefixCls + '-scaller' }, '\u56FE\u50CF\u5DF2\u7F29\u653E\u81F3\u6700\u5927\u6BD4\u4F8B\uFF0C\u65E0\u6CD5\u7EE7\u7EED\u7F29\u653E\u3002');
    }
    return React.createElement("div", { className: prefixCls + '-scaller' }, React.createElement("button", { disabled: value === min }, React.createElement(_Icon2['default'], { type: "picture", className: "smaller" })), React.createElement(_rcSlider2['default'], { className: prefixCls + '-slider', value: value, min: min, max: maxValue, step: 0.0001, onChange: props.onChange }), React.createElement("button", { disabled: value === maxValue }, React.createElement(_Icon2['default'], { type: "picture", className: "larger" })));
}
module.exports = exports['default'];